import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

const OrganizationSwitcher = () => {
  const { availableOrganizations, currentOrganization, switchOrganization } = useAuth();
  const [switching, setSwitching] = useState(false);

  // Don't show if only one or no organizations
  if (!availableOrganizations || availableOrganizations.length <= 1) {
    return null;
  }

  const handleSwitch = async (orgId) => {
    if (orgId === currentOrganization?.id) return;

    setSwitching(true);
    await switchOrganization(orgId);
    setSwitching(false);
  };

  return (
    <div className="bg-white border-b border-gray-200 p-4">
      <label className="block text-xs font-medium text-gray-700 mb-2">
        Managing Committee
      </label>
      <select
        value={currentOrganization?.id || ''}
        onChange={(e) => handleSwitch(parseInt(e.target.value))}
        disabled={switching}
        className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500 text-sm disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {availableOrganizations.map((org) => (
          <option key={org.id} value={org.id}>
            {org.name}
          </option>
        ))}
      </select>
      {switching && (
        <p className="text-xs text-gray-500 mt-2">Switching...</p>
      )}
    </div>
  );
};

export default OrganizationSwitcher;
